// @owners { team: patients }
import { getImage } from '~shared/assets/images/getImage';

// Single source of truth for Progyny screen image assets. All properties are getters (not direct
// imports) so they resolve through getImage(), which handles per-platform asset resolution.
export const progynyAssets = {
  get calculateIcon() {
    return getImage('progynyCalculateIcon');
  },
  get calendarIcon() {
    return getImage('progynyCalendarIcon');
  },
  get logo() {
    return getImage('progynyLogo');
  },
  get medicationsIcon() {
    return getImage('progynyMedicationsIcon');
  },
};
